import React from "react";
import "./performance.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { useParams } from "react-router-dom";
import plusicon from "../../../assets/img/product_img/plusicon.png";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import bannerIMG from "../../../../src/assets/bannerImages/main-img.jpg";
import childImg1 from "../../../assets/img/child-img/indoor playground square fit 1.png";
import childImg2 from "../../../assets/img/child-img/indoor playground square fit 2.png";
import childImg3 from "../../../assets/img/child-img/indoor playground square fit 3.png";
import childImg4 from "../../../assets/img/child-img/indoor playground square fit 4.png";
import WhatsappButton from "../../../components/WhatsappButton";

const Performance = () => {
  const { type } = useParams();
  console.log("type of the product================>>",type);
  let content;

  if (type === "Trampoline") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "100%",
              left: "20%",
              transform: "translate(-50%, 3%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img src={bannerIMG} alt="trampoline parks" className="main-img" />
        </div>

        <h1 className="p-heading">Trampoline</h1>

        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              We Global Entertainment Manufacturer design and manufacture high-quality trampolines for parks worldwide, focusing on innovation, safety, and durability. As a leading Trampoline Supplier in Jordan, we create unforgettable trampoline experiences with our premium products.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  Built with premium materials and reinforced structures, our trampolines are ideal for indoor parks, adventure zones, and entertainment centers. As a leader in  Indoor Playground Production in Jordan , we ensure top-quality designs for safe and exciting play areas.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                Meeting international safety standards, our Trampoline Supplier in Jordan ensures long-lasting performance with high-quality trampolines.
                </h2>

              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  Whether launching a new park or upgrading an existing one, we provide turnkey solutions from design to installation.
                </h2>

              </li>
              <li className="p-text-2">
                
                <h2 className="ProductDetailsPage">
                   We offer customizable designs, including freestyle areas, dodgeball courts, and basketball zones, along with Soft Play Installation in Jordan to enhance safety and fun.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="trampoline park with soft play"
              />
              <img src={childImg3} alt="soft play and trampoline" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="soft play and trampoline" />
              <img src={childImg4} alt="trampoline parks" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "Performance") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "100%",
              left: "20%",
              transform: "translate(-50%, 3%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor family entertainment centers"
            className="main-img"
          />
        </div>
        <h1 className="p-heading">Perfomance Trampoline</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              We Global Entertainment Manufacturer specialize in Trampoline Park Production in Jordan, designing high-quality performance trampolines for trampoline parks. Built with premium materials, our trampolines provide greater height, improved airtime, and ultimate control.
            </h2>
            
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">
            Why Choose Our Performance Trampolines?
            </h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                    <b>Higher Jumps</b> – Engineered with high-tension springs for extreme bounce.
                </h2>
              </li> 
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Safety & Durability</b>– Reinforced frames, UV-resistant mats, and shock-absorbing padding. Perfect for Tricks – Ideal for flips, twists, and freestyle moves. Customizable Design – Tailored to fit any trampoline park layout.
                </h2>
              </li>
              <h3 className="p-sub-heading-2"> Who Benefits?</h3>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Athletes & Gymnasts</b> – Enhances training and performance. Ideal for Freestyle Jumpers to master aerial skills. Trampoline Park Visitors enjoy an elevated fun experience. Trusted by Trampoline Park Manufacturers in Jordan for top-quality performance.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="indoor playground design" />
              <img src={childImg3} alt="playground equipment company" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="soft play" />
              <img src={childImg4} alt="playgrounds and parks" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "BasketballTrampoline") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
                  position: "absolute",
                  top: "100%",
                  left: "20%",
                  transform: "translate(-50%, 3%)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor playground with slide"
            className="main-img"
          />
        </div>
        <h1 className="p-heading"> Basketball Trampoline</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Basketball trampoline, also known as slam dunk trampoline, is an exciting variation of basketball played on a trampoline. Players use the trampoline to execute high-flying dunks and acrobatic moves that would be impossible on a regular basketball court. If you're looking for high-quality trampolines for this sport, consider a reliable Trampoline Supplier in Jordan to ensure safety and durability.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  Our basketball trampoline includes a basketball backboard and rim, which are designed to withstand the force of players dunking the ball.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                For safety purposes,GEM basketball trampolines have padding around the frame and other areas to protect players from impact and safety nets or walls around the perimeter to prevent players or balls from bouncing out of the playing area.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="trampoline park with soft play"
              />
              <img
                src={childImg3}
                alt="playground equipment suppliers"
              />{" "}
            </div>
            <div className="p-img-left-box">
              <img
                src={childImg2}
                alt="playground equipment catalog"
              />
              <img src={childImg4} alt="soft play installation" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "FoamPit-BalanceZone") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
              style={{
                  position: "absolute",
                  top: "100%",
                  left: "20%",
                  transform: "translate(-50%, 3%)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="highest quality trampoline"
            className="main-img"
          />
        </div>

        <h1 className="p-heading">Foam Pit / Balance Zone</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
              <h2 className="ProductDetailsPage">
                A foam pit trampoline is a type of trampoline that includes a foam
                pit at the end of the jumping surface. This allows users to safely
                jump, flip, and perform acrobatic maneuvers into a play area area.
              </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  The size of the foam pit can be very big, but it is large enough to accommodate multiple users at once.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  The bouncing surface of a foam pit trampoline, supplied by a Trampoline Park Supplier in Jordan, is crafted from a strong and durable material like polypropylene, securely attached to the frame using high-quality springs.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  The bouncing surface is designed to provide a high-quality bounce while also being gentle on users' joints.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="indoor playground with slide"
              />
              <img
                src={childImg3}
                alt="indoor commercial playground"
              />{" "}
            </div>
            <div className="p-img-left-box">
              <img
                src={childImg2}
                alt="playground equipment manufacturer"
              />
              <img
                src={childImg4}
                alt="playTurn on screen reader supportground equipment catalog"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "DodgeBall") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
             style={{
              position: "absolute",
              top: "100%",
              left: "20%",
              transform: "translate(-50%, 3%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment suppliers"
            className="main-img"
          />
        </div>
        <h1 className="p-heading">Dodge Ball</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
            Dodgeball trampoline is an exciting variation of dodgeball played in trampoline parks. It blends the classic game of dodgeball with the thrill of bouncing, adding an extra layer of challenge and fun. As part of the growing trend of trampoline park production in Jordan, this activity has gained popularity for its energetic and engaging gameplay.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  GEM Dodgeball trampolines are larger than standard trampolines to accommodate multiple players. Additionally, they feature stronger springs to provide higher bounces, enabling the unique maneuvers required in the game. As a leading trampoline park manufacturer in Jordan, GEM ensures high-quality designs that enhance both safety and performance for an exhilarating dodgeball experience.
                </h2>
              </li>
              {/* {" "} */}
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  To ensure the safety of players, our dodgeball trampolines have padding around the frame and other areas to protect players from impact.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="commercial indoor playground equipment"
              />
              <img src={childImg3} alt="playgrounds" />{" "}
            </div>
            <div className="p-img-left-box">
              <img
                src={childImg2}
                alt="indoor commercial playground"
              />
              <img
                src={childImg4}
                alt="highest quality trampoline"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "WipeOut") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "100%",
              left: "20%",
              transform: "translate(-50%, 3%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor commercial playground"
            className="main-img"
          />
        </div>
        <h1 className="p-heading">Wipe Out</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              Wipe Out is a thrilling equipment where trampoline players attempt to jump over two motor-powered, soft rotating cylinders. The objective of the game is to stay on without falling, and the last player standing is declared the winner.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  Designed to accommodate multiple players at once, Wipe Out can be integrated into a trampoline park or installed as a standalone attraction. To maintain safety and optimal performance, regular motor maintenance is essential. As a leading family entertainment centers manufacturer in Jordan, we ensure high-quality designs that enhance durability and excitement for all visitors.
                </h2>
              </li>
              {/* {" "} */}
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="indoor playground" />
              <img
                src={childImg3}
                alt="playground equipment catalog"
              />{" "}
            </div>
            <div className="p-img-left-box">
              <img
                src={childImg2}
                alt="indoor commercial playground"
              />
              <img
                src={childImg4}
                alt="commercial indoor playground equipment"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "AirBag") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "100%",
              left: "20%",
              transform: "translate(-50%, 3%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment manufacturers"
            className="main-img"
          />
        </div>
        <h1 className="p-heading"> Air Bag</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 className="ProductDetailsPage">
              At Global Entertainment Manufacturer, we design and manufacture high-quality Air Bags for trampoline parks, providing the safest and most thrilling landing experience. Our Air Bags are made with high-pressure, durable materials to ensure maximum safety and longevity.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">Why Choose Our Air Bags?</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Superior Safety</b> – Designed to absorb impact, reducing the risk of injury.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>High Durability</b> – Made with reinforced materials for long-lasting performance.
                </h2>
              </li>
              <h3 className="p-sub-heading-2">Who Benefits?</h3>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Smooth & Controlled Landing</b> – Evenly distributes pressure for a soft and stable landing.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Perfect for High Jumps & Stunts</b> – Designed for trampoline park enthusiasts performing aerial tricks, our equipment meets the highest standards. As a leader in indoor playground production in Jordan, we ensure top-quality designs that enhance performance and safety.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 className="ProductDetailsPage">
                  <b>Customizable Design</b>– Available in various sizes and colors to fit your park’s theme.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="playground equipment manufacturers"
              />
              <img src={childImg3} alt="trampoline company" />{" "}
            </div>
            <div className="p-img-left-box">
              <img
                src={childImg2}
                alt="playground equipment company"
              />
              <img src={childImg4} alt="soft play installation" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <Helmet>
        <meta
          name="trampoline park with soft play"
          content="GEM specializes in soft play installation, creating safe, 
fun, and engaging play areas for children. Enhance
 your space with our expert soft play solutions!"
        />

        <meta
          name="soft play and trampoline"
          content="Experience the highest quality trampoline and soft
 play installation with GEM. Safe, durable, and fun 
designs tailored for ultimate entertainment 
and excitement!"
        />

        <meta
          name="soft play and trampoline"
          content="Experience the ultimate fun at GEM Trampoline Parks! 
Jump, flip, and soar in our exciting indoor arenas, 
perfect for all ages. Visit GEM for nonstop adventure!"
        />

        <meta
          name="trampoline parks"
          content="Experience the highest quality trampoline with GEM, 
designed for ultimate safety, durability, and 
performance. Perfect for endless fun and fitness 
for all ages"
        />

        <meta
          name="indoor family entertainment centers"
          content="Discover GEM's high-quality commercial indoor 
playground equipment, designed for safety, fun, 
and durability. Perfect for indoor play areas, 
gyms, and more!"
        />

        <meta
          name="indoor playground design"
          content="Discover GEM's high-quality commercial indoor
 playground equipment, designed for safety, fun, 
and durability. Perfect for indoor play areas, gyms,
 and more!"
        />
        <meta
          name="indoor play equipment commercial"
          content="Discover high-quality indoor play equipment 
commercial solutions for businesses. Safe, durable, 
and fun play structures perfect for entertainment and
 learning spaces."
        />
      </Helmet>
      <Header />
      <div>
        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
        <Link
          to="/getquotations"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="icon-container">
            <img
              src={plusicon}
              alt="soft play installation"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>
      {content}
      <Footer />
    </div>
  );
};

export default Performance;
